import { useEffect, useMemo, useState } from 'react'
import { supabase } from '../lib/supabase.js'
import { createSharedCommandSync } from '../lib/sharedCommandSync.js'
import { createCommandAccountSync } from '../lib/commandAccountSync.js'
import { combineCommandPreferenceChannels } from '../lib/commandPreferenceChannels.js'

export function useCommandAccountSync(userId) {
  const [, render] = useState(0)
  const controller = useMemo(() => {
    const serviceUrl = import.meta.env.VITE_COMMAND_PROFILE_SERVICE_URL
    const environment = import.meta.env.VITE_COMMAND_PROFILE_ENVIRONMENT
    const options = {
      serviceUrl, environment,
      userId,
      project: import.meta.env.VITE_SUPABASE_URL || 'unconfigured',
      client: supabase,
      storage: typeof localStorage === 'undefined' ? null : localStorage,
      onChange: () => render(n => n + 1),
    }
    const account = createCommandAccountSync(options)
    return serviceUrl ? combineCommandPreferenceChannels(createSharedCommandSync(options), account) : account
  }, [userId])
  useEffect(() => {
    controller.activate()
    controller.refresh()
    const refresh = () => controller.refresh()
    const timer = setInterval(refresh, 30000)
    window.addEventListener('focus', refresh)
    window.addEventListener('online', refresh)
    return () => {
      controller.dispose()
      clearInterval(timer)
      window.removeEventListener('focus', refresh)
      window.removeEventListener('online', refresh)
    }
  }, [controller])
  return { ...controller.get(), controller }
}
